<template>
  <RouterView v-if="ready"/>
  <Loader v-else/>
  <Gdpr/>
  <Tooltip/>
</template>

<script>
import {Loader} from '@/components/small'
import Gdpr from '@/components/gdpr/Gdpr.vue'
import {Tooltip} from '@/components/modal'

export default {
  name: 'App',
  data() {
    return {
      ready: false
    }
  },
  components: {
    Gdpr,
    Loader,
    Tooltip
  },
  async mounted() {
    await this.$auth.init()

    this.ready = true
  }
}
</script>
